// extracted by mini-css-extract-plugin
export default {"list":"Menu-module__list--b7YCx","item":"Menu-module__item--jn4rp"};